import { useQuery } from '@tanstack/react-query';
import { searchLabourDefinitions } from '../api/labourItemsApi.ts';

/**
 * Query key factory for labour-related queries
 * Following react-query-patterns.md
 */
export const labourKeys = {
  all: ['labour'] as const,
  definitions: () => [...labourKeys.all, 'definitions'] as const,
  allDefinitions: () => [...labourKeys.definitions(), 'all'] as const,
  search: (searchTerm: string) =>
    [...labourKeys.definitions(), 'search', searchTerm] as const,
};

/**
 * Query hook for fetching ALL labour definitions (preloaded for autocomplete)
 * Following react-query-patterns.md
 */
export const useAllLabourDefinitions = () => {
  return useQuery({
    queryKey: labourKeys.allDefinitions(),
    queryFn: ({ signal }) => searchLabourDefinitions('', signal), // Empty string fetches all
    placeholderData: previousData => previousData,
    staleTime: 1000 * 60 * 10, // 10 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
  });
};

/**
 * Query hook for searching labour definitions (autocomplete) - DEPRECATED
 * Use useAllLabourDefinitions instead and filter client-side
 * @deprecated
 */
export const useLabourDefinitionSearch = (
  searchTerm: string,
  options?: {
    enabled?: boolean;
  }
) => {
  return useQuery({
    queryKey: labourKeys.search(searchTerm),
    queryFn: ({ signal }) => searchLabourDefinitions(searchTerm, signal),
    placeholderData: previousData => previousData,
    enabled: options?.enabled !== false && searchTerm.length >= 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes (renamed from cacheTime)
  });
};
